import fireEvent from 'react-app-events/lib/fireEvent'
import {EVENTS, sendPosthogData} from '@helpers/posthog'
import useTrackEcommerceEvent, {ECOMMERCE_EVENTS} from '@helpers/track/useTrackEcommerceEvent'
import useMessage from '@hooks/useMessage'
import {useClient, useMutate} from '@packages/apollo-hooks'

import mutation from './mutation'
import mutationEdit from './mutationEdit'
import optimisticUpdateCart from './optimisticUpdateCart'

export default function useAdd() {
  const mutate = useMutate()
  const showMessage = useMessage()
  const client = useClient()
  const trackEcommerceEvent = useTrackEcommerceEvent()

  // TODO (Important): Refactor and set types
  return async (
    props,
    state,
    product,
    resume,
    opts: {setLoading?: (boolean) => void; keepLoadingOnFinish?: boolean} = {}
  ) => {
    const {setLoading, keepLoadingOnFinish} = opts
    let success = false

    if (resume.missingModifier) {
      fireEvent('scrollToRequiredModifier', resume.missingModifier)
      return
    }

    if (setLoading) setLoading(true)
    try {
      const variables = {
        productId: props.product._id,
        amount: state.amount,
        modifiers: state.modifiers,
        comment: state.comment,
        menuId: props.menuId
      }

      if (props.cartItem) {
        await mutate({
          mutation: mutationEdit,
          variables: {
            cartItemId: props.cartItem._id,
            ...variables
          },
          refetchQueries: ['getMyCart', 'getMyOrderPreferences']
        })
      } else {
        optimisticUpdateCart({client, props, state, product})
        const {item} = await mutate({
          mutation,
          variables,
          refetchQueries: ['getMyCart', 'getMyOrderPreferences']
        })

        await trackEcommerceEvent(ECOMMERCE_EVENTS.ADDTOCART, {product, item, amount: state.amount})
        sendPosthogData(EVENTS.clicked.productAddToCart, {
          ...product,
          ...item,
          amount: state.amount
        })
      }

      if (props.onAdd) {
        props.onAdd()
      }

      props.close()
      success = true
    } catch (error) {
      showMessage(error)
    }

    // In some cases, we want to keep showing the loading state until the location changes
    if (setLoading && !keepLoadingOnFinish && !success) setLoading(false)
  }
}
